const vi_VN = {
    homepage_title: 'Tải xuống CalendarTask phiên bản di động bằng mã QR',
    homepage_slogn: 'CalendarTask phiên bản di động',
    homepage_ios_download: 'App Store đang xem xét...',
    homepage_download: 'Tải xuống',
    homepage_url_calendar: 'https://image.idesktopcal.com/homepage/calendar_normal_chs.png',
    homepage_url_list: 'https://image.idesktopcal.com/homepage/list_normal_chs.png',
    homepage_url_color: 'https://image.idesktopcal.com/homepage/color_normal_chs.png',

    phonedownload_title: 'Tải xuống CalendarTask phiên bản di động bằng mã QR',
    phonedownload_slogan: 'Đồng bộ với PC và máy tính bảng, ghi chú mọi nơi',
    phonedownload_send_vip: 'Cài đặt ứng dụng và nhận VIP',
    phonedownload_screenshot: 'Ảnh chụp màn hình',
    phodedownload_macos: 'CalendarTask phiên bản macOS',
    phodedownload_windows: 'CalendarTask phiên bản Windows',
    phodedownload_otherbutton: 'Xem ngay',
    phodedownload_about: 'Liên hệ',
    phodedownload_copyright: '京ICP备18016017号-7',

    feature_no_ad: 'Không quảng cáo',
    feature_easy: 'Chế độ xem tháng, đơn giản và dễ dùng',
    feature_reminder: 'Nhắc nhở tùy chỉnh',
    feature_countdown: 'Đếm ngược ngày kỷ niệm',

    vip_task_succ: 'Thành công. Tải ứng dụng để kích hoạt VIP',
    vip_task_error: 'Nhận thất bại',

    group_slogn: 'Lời mời CalendarTask nhóm',

    tt_title: 'CalendarTask',
    tt_share_1: 'Chia sẻ với bạn',
    tt_share_2: 'Thời khóa biểu',
    tt_share_show_1: 'Quét mã QR bằng ứng dụng "CalendarTask", PC và điện thoại sẽ hiển thị',
    tt_share_show_2: 'thời khóa biểu',
    tt_share_scan_1: 'Quét bằng',
    tt_share_scan_2: 'ứng dụng "CalendarTask"',
    tt_share_succ: 'Đồng bộ thành công',

    v2_copyright: 'Liên hệ service@xiaoweiyunfu.com<br/>Copyright © 2025 Xiaowei Cloud, Inc. Đã đăng ký bản quyền.',
    v2_download_appstore: 'Tải xuống trên App Store',
    v2_download_googleplay: 'Có sẵn trên Google Play',

    v2_main_title: 'CalendarTask Di động',
    v2_main_title_part1: 'CalendarTask',
    v2_main_title_part2: 'Di động',
    v2_main_description: 'Tìm <span class="name">CalendarTask</span> trên App Store hoặc Google Play',
    v2_download_ios: 'Tải xuống iOS',
    v2_download_android: 'Tải xuống Android',
    v2_download_harmonyos: 'Tải xuống HarmonyOS',
    v2_sync_status: 'Đồng bộ hoàn tất! 1 tải lên, 0 tải xuống',
    v2_feature_title: 'Đồng bộ dữ liệu đa thiết bị',
    v2_feature_description: 'Đồng bộ giữa điện thoại, máy tính bảng và PC'
};
export default vi_VN;
